import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";

const fd = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR") : "—");

/** Entreprises abonnées via Stripe + synchronisation des statuts. */
export function StripeSubscriptionsTable({ enabledKey }) {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/stripe/subscriptions").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const sync = async () => {
    setBusy(true);
    try { const { data } = await api.post("/admin/stripe/subscriptions/sync-all"); toast.success(`Synchronisation : ${data.updated} mis à jour / ${data.checked} vérifiés${data.errors ? ` · ${data.errors} erreur(s)` : ""}`); await load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="bg-white border border-[#DEE2E6]" data-testid="stripe-subscriptions">
      <div className="p-4 border-b border-[#DEE2E6] flex items-center justify-between gap-3 flex-wrap">
        <div className="text-xs uppercase tracking-[0.2em] font-semibold">Abonnements Stripe <span className="text-[#868E96] normal-case tracking-normal font-normal">— {rows.length} entreprise(s)</span></div>
        <Button size="sm" variant="outline" onClick={sync} disabled={busy || !enabledKey || !rows.length} data-testid="stripe-sync-all" className="h-8 text-[10px]"><RefreshCw className="h-3 w-3 mr-1" />Synchroniser avec Stripe</Button>
      </div>
      {!rows.length ? <div className="p-6 text-xs text-[#868E96]" data-testid="stripe-subscriptions-empty">Aucune entreprise abonnée via Stripe pour l'instant (les nouvelles inscriptions payées par carte apparaîtront ici).</div> : (
        <div className="divide-y divide-[#F1F3F5]">
          {rows.map((e) => (
            <div key={e.id} className="px-4 py-3 flex items-center gap-3 flex-wrap text-xs" data-testid={`stripe-sub-${e.code}`}>
              <div className="flex-1 min-w-[200px]"><span className="font-semibold text-sm">{e.name}</span> <span className="font-mono text-[10px] text-[#868E96]">{e.code}</span></div>
              <span className="font-mono text-[10px] text-[#495057]">{e.stripe_subscription_id}</span>
              <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 ${["active", "trialing"].includes(e.stripe_subscription_status) ? "bg-[#059669] text-white" : e.stripe_subscription_status ? "bg-[#E60000] text-white" : "bg-[#DEE2E6]"}`}>{e.stripe_subscription_status || "non synchronisé"}</span>
              <span className="text-[#495057]">{e.last_payment_period === "monthly" ? "mensuel" : "annuel"} · échéance {fd(e.payment_due_date)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
